import { CQ_POTS } from '../catalogConstants';

export const PAYMENT_TYPES = {
  CARD: 'CARD',
  FUNDED: 'FUNDED',
  DIRECT_DEBIT: 'DIRECT_DEBIT',
};

export const getPaymentMethodNormalized = (selectedPaymentMethod) => {
  if (selectedPaymentMethod === CQ_POTS.PAYMENT_POT.FUNDED
    || selectedPaymentMethod === CQ_POTS.PAYMENT_POT.FUNDED_NO_TAXES
    || selectedPaymentMethod === CQ_POTS.PAYMENT_POT.FUNDED_SPECIAL_TAXES
  ) {
    return PAYMENT_TYPES.FUNDED;
  }

  if (selectedPaymentMethod === CQ_POTS.PAYMENT_POT.CARD) {
    return PAYMENT_TYPES.CARD;
  }

  return PAYMENT_TYPES.DIRECT_DEBIT;
};

export const isFundingPayment = poptSelected => (
  (poptSelected === CQ_POTS.PAYMENT_POT.FUNDED
  || poptSelected === CQ_POTS.PAYMENT_POT.FUNDED_NO_TAXES
  || poptSelected === CQ_POTS.PAYMENT_POT.FUNDED_SPECIAL_TAXES)
);
